// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/Images/DownArrow.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar-style {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
}

.navbar-style .dropdown-item.active {
    color: #1476FF !important;
    background-color: #F4F7FF !important;
}

.navbar-style .dropdown-item:active {
    color: unset;
    background-color: unset;
}

.navbar-style .dropdown-item.active .Link:hover {
    background-color: #f3f3f3 !important;
    color: inherit;
}

.navbar-style a {
    color: inherit !important;
}

.navbar-style a:hover {
    background-color: none !important;
}

.dropdown-toggle::after {
    content: "";
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    height: 18px;
    width: 18px;
    padding: 0 10px;
    margin-top: 4px;
    /* margin-left: 10px; */
    background-repeat: no-repeat;
    background-size: contain;
    border: none !important;
    position: absolute;
    transition: all 0.2s;
}

.show::after {
    margin-top: 10px;
    transform: rotate(-180deg) translateY(40%);
    transition: all 0.2s;
}

.black > .dropdown-menu {
    border-radius: 23px;
    padding: 8px 15px;
    background-color: black;
    border: 1px solid #302f30;
}
.white > .dropdown-menu {
    border-radius: 23px;
    padding: 8px 15px;
    background-color: white;
}
.Link {
    text-decoration: none;
    margin-left: 10px;
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 500;
}

.navbar-style .nav-link.active {
    color: #3545EE !important;
}
#collasible-nav-dropdown-4{
    padding: 1px !important;
}

.popover-body-black{
    max-height: 250px;
    overflow: auto;
    background: black;
    color: white;
}

.popover-body-white{
    max-height: 250px;
    overflow: auto;
    background: #f0f0f0;
    color: black;
}
.popover-body::-webkit-scrollbar{
    width: 0px;
}`, "",{"version":3,"sources":["webpack://./src/Component/Navbar/Navbar.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,4CAA4C;AAChD;;AAEA;IACI,yBAAyB;IACzB,oCAAoC;AACxC;;AAEA;IACI,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,mDAAkD;IAClD,YAAY;IACZ,WAAW;IACX,eAAe;IACf,eAAe;IACf,uBAAuB;IACvB,4BAA4B;IAC5B,wBAAwB;IACxB,uBAAuB;IACvB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAKhB,0CAA0C;IAC1C,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,uBAAuB;IACvB,yBAAyB;AAC7B;AACA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,uBAAuB;AAC3B;AACA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,UAAU;AACd","sourcesContent":[".navbar-style {\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);\n}\n\n.navbar-style .dropdown-item.active {\n    color: #1476FF !important;\n    background-color: #F4F7FF !important;\n}\n\n.navbar-style .dropdown-item:active {\n    color: unset;\n    background-color: unset;\n}\n\n.navbar-style .dropdown-item.active .Link:hover {\n    background-color: #f3f3f3 !important;\n    color: inherit;\n}\n\n.navbar-style a {\n    color: inherit !important;\n}\n\n.navbar-style a:hover {\n    background-color: none !important;\n}\n\n.dropdown-toggle::after {\n    content: \"\";\n    background: url(../../assets/Images/DownArrow.svg);\n    height: 18px;\n    width: 18px;\n    padding: 0 10px;\n    margin-top: 4px;\n    /* margin-left: 10px; */\n    background-repeat: no-repeat;\n    background-size: contain;\n    border: none !important;\n    position: absolute;\n    transition: all 0.2s;\n}\n\n.show::after {\n    margin-top: 10px;\n    -webkit-transform: rotate(-180deg) translateY(40%);\n    -moz-transform: rotate(-180deg) translateY(40%);\n    -ms-transform: rotate(-180deg) translateY(40%);\n    -o-transform: rotate(-180deg) translateY(40%);\n    transform: rotate(-180deg) translateY(40%);\n    transition: all 0.2s;\n}\n\n.black > .dropdown-menu {\n    border-radius: 23px;\n    padding: 8px 15px;\n    background-color: black;\n    border: 1px solid #302f30;\n}\n.white > .dropdown-menu {\n    border-radius: 23px;\n    padding: 8px 15px;\n    background-color: white;\n}\n.Link {\n    text-decoration: none;\n    margin-left: 10px;\n    font-family: 'Montserrat';\n    font-style: normal;\n    font-weight: 500;\n}\n\n.navbar-style .nav-link.active {\n    color: #3545EE !important;\n}\n#collasible-nav-dropdown-4{\n    padding: 1px !important;\n}\n\n.popover-body-black{\n    max-height: 250px;\n    overflow: auto;\n    background: black;\n    color: white;\n}\n\n.popover-body-white{\n    max-height: 250px;\n    overflow: auto;\n    background: #f0f0f0;\n    color: black;\n}\n.popover-body::-webkit-scrollbar{\n    width: 0px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
